import React,{ useRef } from 'react';
import axios from 'axios'
import { Tooltip,Popover,Result,Table,Popconfirm,Input,Switch, Button,Collapse,Card,Avatar,Modal,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon, { PrinterOutlined, MinusOutlined, CloseCircleFilled, CheckCircleOutlined, UserOutlined } from '@ant-design/icons';
import { DeleteOutlined,SearchOutlined,CameraOutlined,PlusOutlined,EditOutlined,PlusSquareFilled,SaveOutlined,LoadingOutlined } from '@ant-design/icons';
import QrReader from 'react-qr-reader'
import uuid from 'react-uuid'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';
import PrintTemplate from 'react-print';
import ReactToPrint from 'react-to-print';
import {
  Col,
  Row,
} from 'reactstrap';
import CurrencyFormat from 'react-currency-format';
import * as serverconfig from '../serverconn'
import * as reactstrp from 'reactstrap';
import { ToWords } from 'to-words';
import { array, number } from 'prop-types';

var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const { Title } = Typography;
const { TextArea } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const toWords = new ToWords();

message.config({
  top: 200,
  duration: 2,
  maxCount: 3,
  rtl: true,
});


var token= ''
var sacco= ''
var username=''



class LoanBadDebtPayOffForm extends React.Component {

  state = {
    date:moment().format(dateFormat).toString(),
    selectedaccount:'',
    selectedaccountobject:{},
    members:[],
    datarequested:true,
    slipnumber:'',
    paidinby:'',
    transactorcontact:'',
    availableloans:[],
    datasubmittedsuccessfully:false,
    lastslipnumber:0,
    selectedloan:'',
    loanschedules:[],
    principleamount:0,
    fine:0,
    debitaccount:'',
    disabledamount:false,
    selectedloanobject:{},

    totalprincipletobepaid:0,
    totalinteresttobepaid:0,
    totalprinciplepaid:0,
    totalinterestpaid:0,

    interestamount:0,
    loanaccountcreditingmethod:'directcashcrediting',
    companyaccounts: [],
    debited_account:'',
    creditloanaccount:'no',

    earlypayoff:false,
    intrest_due:0,
    no_dueschedules:0,
    remaining_schedule_totals_interest:0,

    intrest_due:0,
    principle_due:0,
    interest_balance:0,
    principle_balance:0,
    cycles_due:0,
    installment_amount:0,


  }

  callback(key) {
    console.log(key);
  }

  componentDidMount(){
    var loan_id=this.props.loan_id

    if(localStorage.getItem("sacco")){
      sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
      username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
   
   }else{
      sacco= ''
      username=''
   }
   
   if(localStorage.getItem("token")){
      token= localStorage.getItem("token")
   }else{
      token= ''
   }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(serverconfig.backendserverurl+`/api/members/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          members:res.data
        })
       // this.setState({datarequested:false})
    })


    axios.get(serverconfig.backendserverurl+`/api/companyaccounts/?sacco=${sacco}`)
    .then(res => {
        this.setState({
            companyaccounts:res.data
        })
        this.setState({datarequested:false})
    })


    //loan loan details
    this.handleselectedloanChange(loan_id)

  }


  
  ////////////////////////////////////
  // PRODUCT SEARCH SELECT METHODS
   onBlur=()=> {
    console.log('blur');
  }
  
   onFocus=()=>{
    console.log('focus');
  }
  
  onSearch=(val)=> {
    console.log('search:', val);
  }

  handleselectedaccountChange= (e) =>{
    this.setState({ selectedaccount: e});
    //make query for last transactions
    axios.get(`${serverconfig.backendserverurl}/api/members/${e}`)
      .then(res => {  
          this.setState({selectedaccountobject: res.data})
      })

      axios.get(`${serverconfig.backendserverurl}/api/loanissues/?account=${e}`)
      .then(res => {  
          this.setState({availableloans: res.data})
          console.log(res.data)
      })

      this.setState({slipnumber:Number(this.state.lastslipnumber)+1})
  }


  //handle client change
  handleselectedloanChange= (e) =>{
    this.setState({selectedloan:e});

    axios.get(`${serverconfig.backendserverurl}/api/loanschedules/?loanissue=${e}`)
    .then(res => {  
        this.setState({loanschedules: res.data})
    })

    axios.get(`${serverconfig.backendserverurl}/api/loanissues/${e}`)
    .then(res => {  
        this.setState({selectedloanobject: res.data})

        //set account
        this.handleselectedaccountChange(res.data.account)
    })


    var totalptobe=0
    var totalitobe=0

    //get all payments now
    axios.get(`${serverconfig.backendserverurl}/api/loanschedules/?loanissue=${e}`)
    .then(res => {  
      totalptobe= res.data.reduce((Total, item) => Total + item.principle, 0);
      totalitobe = res.data.reduce((Total, item) => Total + item.interest, 0);

      this.setState({totalprincipletobepaid:totalptobe})   
      this.setState({totalinteresttobepaid:totalitobe.toFixed(2)})   

    })
    
    var totalppaid=0
    var totalipaid=0

    axios.get(`${serverconfig.backendserverurl}/api/loanrepayments/?loanissue=${e}`)
    .then(res => {  

       totalppaid = res.data.reduce((Total, item) => Total + item.principle_paid, 0);
       totalipaid = res.data.reduce((Total, item) => Total + item.interest_paid, 0);

      this.setState({totalprinciplepaid:totalppaid})   
      this.setState({totalinterestpaid:totalipaid})  

      //set the principle and intrest pay
      this.setState({principleamount:totalptobe-totalppaid})
      this.setState({interestamount:totalitobe-totalipaid})
    })


    axios.get(`${serverconfig.backendserverurl}/customqueries/getloan_interestdue/${e}`)
    .then(res => {  
        this.setState({intrest_due: res.data.intrest_due})
        this.setState({no_dueschedules:res.data.no_dueschedules})
        this.setState({remaining_schedule_totals_interest:res.data.remaining_schedule_totals_interest})

     })


   //get due details
    axios.get(`${serverconfig.backendserverurl}/customqueries/getloanpay_figures/${e}`)
    .then(res => {  
  
        this.setState({intrest_due: res.data.report.intrest_due})
        this.setState({principle_due: res.data.report.principle_due})
        this.setState({interest_balance: res.data.report.interest_balance})
        this.setState({principle_balance: res.data.report.principle_balance})
        this.setState({cycles_due: res.data.report.cycles_due})
    })


  }


  handleprincipleamountChange= (e) => this.setState({ principleamount: e.target.value});
  handlefineChange= (e) => this.setState({ fine: e.target.value});


  //submit the deposit now
  handleFormSubmit=(event) =>{

      this.setState({datarequested:true})
  
      let form_data = new FormData();

      form_data.append('sacco', sacco);
      form_data.append('username', username);
      form_data.append('loanid', this.state.selectedloan);
      form_data.append('date', this.state.date);

      axios.post(serverconfig.backendserverurl+'/customqueries/loanbaddebtpayoff', form_data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
        })
      .then(res => {
        this.setState({datarequested:false})
        message.info(res.data.message)


        //get all payments now
        axios.get(`${serverconfig.backendserverurl}/api/loanschedules/?loanissue=${this.state.selectedloan}`)
        .then(res => {  
          const totalptobe = res.data.reduce((Total, item) => Total + item.principle, 0);
          const totalitobe = res.data.reduce((Total, item) => Total + item.interest, 0);

          this.setState({totalprincipletobepaid:totalptobe})   
          this.setState({totalinteresttobepaid:totalitobe})   

        })
        
        
        axios.get(`${serverconfig.backendserverurl}/api/loanrepayments/?loanissue=${this.state.selectedloan}`)
        .then(res => {  

          const totalppaid = res.data.reduce((Total, item) => Total + item.principle_paid, 0);
          const totalipaid = res.data.reduce((Total, item) => Total + item.interest_paid, 0);

          this.setState({totalprinciplepaid:totalppaid})   
          this.setState({totalinterestpaid:totalipaid})  

        })

        this.setState({datasubmittedsuccessfully:true})
        
      })
      .catch(error => console.log(error))
     

  }

  //calculate percetabge of ramaining schedule interest
  cal_percenatageoffremaingschedules_int=()=>{
    var total=0
    var percentage=Number(this.state.selectedloanobject.percentageof_remainginginterest_on_earlypayoff) 
    var pctg=(percentage/100)*Number(this.state.remaining_schedule_totals_interest)
    total=pctg
    return total;
  }

    //calculate percetabge of ramaining schedule interest
    calculatepercentageoff_fisrtinstall_interest_incaseofno_intdue=()=>{
      var total=0
      var percentage=Number(this.state.selectedloanobject.percentageonfirstinst_interest_incase_no_dueinterest_onloanpayoff) 
      
      if (this.state.loanschedules.length>0){
        var pctg=(percentage/100)*Number(this.state.loanschedules[0].interest)
        total=pctg
      }
      
      return total;
  
    }


  //calcultae interst payoff
  calculateInterstPayoff=()=>{
    var total=0
    var intr_due=Number(this.state.intrest_due)

    if(Number(intr_due)>0){
      total+=intr_due
      total+=this.cal_percenatageoffremaingschedules_int()
    }else{
      total+=this.calculatepercentageoff_fisrtinstall_interest_incaseofno_intdue()
      total+=this.cal_percenatageoffremaingschedules_int()
    }

    return total;
  }

  



  ////////////////////////////////////////////
  // RENDERING METHOD HERE
  render() {

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
                <div className="content" />
              </Spin> 
         </div>
      )

    }else{
      if(this.state.datasubmittedsuccessfully===true){
        return(
          <div>

            <Row >
                  <Col xs="12" sm="6" lg="6">
                    <Card>
                    <Result
                    status="success"
                    title="Successfully Made Loan PayOff "
                    subTitle="Please finish off transaction"
                    extra={[
                      <Button  type='primary' onClick={()=>{window.location.reload(false)}}>Finish</Button>,
                     
                    ]}
                    />
                    </Card>
                  </Col>
            </Row>
          </div>

        )

      }else{
        return(
          <div>
            <div>
  
              <Row >
                  <Col xs="12" sm="6" lg="12">
                    <Card>
                    <h3 style={{fontWeight:'bolder',color:'#154360'}}>Bad Debt PayOff</h3>

                    <FormItem label=" Select Member Account">
                        <Select 
                        placeholder="Account No | Name" 
                        style={{  }} 
                        value={this.state.selectedaccount}
                        onChange={this.handleselectedaccountChange} 
                        showSearch
                        optionFilterProp="children"
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        onSearch={this.onSearch}               
                        >
                          {this.state.members.map(
                            (accnt)=>(
                              <Option value={accnt.id}>{accnt.AccountNumber} | {accnt.FullName}</Option>
                            ))}
                        </Select>
                    </FormItem>

                    
                    <FormItem label="Select Loan to Repay">
                        <Select 
                        placeholder="Select Loan to Repay" 
                        style={{  }} 
                        value={this.state.selectedloan}
                        onChange={this.handleselectedloanChange} 
                        showSearch
                        optionFilterProp="children"
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        onSearch={this.onSearch}
                                              
                        >
                          {this.state.availableloans.map(
                            (loan)=>(
                              <Option value={loan.id}>Amount {loan.approved_amount} | Date {loan.date} | Months {loan.loan_period}</Option>
                            ))}
                        </Select>
                      </FormItem>
                      <br></br>

                      <reactstrp.Table bordered>
                        <thead>
                          <tr>
                            <th>
                            <h4>Account Number:{this.state.selectedaccountobject.AccountNumber}</h4>
                            <h4>Account Contact:{this.state.selectedaccountobject.RegisteredPhoneNumber1}</h4>
                            <h4>Account Name:{this.state.selectedaccountobject.FullName}</h4>
                            <h4>Account Balance:<CurrencyFormat value={this.state.selectedaccountobject.savings_balance} displayType={'text'} thousandSeparator={true}  /> </h4>
                            <h4>Status:{this.state.selectedaccountobject.account_status}</h4>

                              
                            </th>
                            <th>
                            <h4>Loan Amount:<CurrencyFormat value={this.state.totalprincipletobepaid} displayType={'text'} thousandSeparator={true}  /> </h4>
                            <h4>Interest Amount To be Paid:<CurrencyFormat value={this.state.totalinteresttobepaid} displayType={'text'} thousandSeparator={true}  /> </h4>
                            <h4>Interest due:<CurrencyFormat value={this.state.intrest_due} displayType={'text'} thousandSeparator={true}  /> </h4>
                            <h4>Principle due:<CurrencyFormat value={this.state.principle_due} displayType={'text'} thousandSeparator={true}  /> </h4>

                            <h4>Cycles due: {this.state.cycles_due}</h4>


                            </th>
                            <th>
                            <h4>Principle Paid:<CurrencyFormat value={this.state.totalprinciplepaid} displayType={'text'} thousandSeparator={true}  /> </h4>
                            <h4>Interest Paid:<CurrencyFormat value={this.state.totalinterestpaid} displayType={'text'} thousandSeparator={true}  /> </h4>

                            <h4>Interest in default:<CurrencyFormat value={this.state.interest_balance} displayType={'text'} thousandSeparator={true}  /> </h4>
                            <h4>Principle in default:<CurrencyFormat value={this.state.principle_balance} displayType={'text'} thousandSeparator={true}  /> </h4>



                            </th>

                          </tr>
                        </thead>
                     
                      </reactstrp.Table>


                    <br></br>

                    <h3 style={{fontWeight:'bold',alignSelf:'center',color:'#154360'}}>LOAN REPAYMENT FORM</h3>
                    <Form
                      onFinish={(event) => this.handleFormSubmit(event)}
                    >

                    <FormItem label="Date"
                      name='date'
                      rules={[
                        {
                          required: true,
                          message: 'Please Select date',
                        },
                      ]}
                    >
                        <DatePicker value={moment()} onChange={(date, dateString)=>{this.setState({ date: dateString})}} format={dateFormat} />
                    </FormItem>
                
                    <FormItem>
                      <Button  type="primary" htmlType="submit">PayOff</Button>
                    </FormItem>
                  </Form>
  
                  </Card>
                  
                </Col>
  
            </Row>
  
            </div>
  
       </div>              
                      
        )
      }

    }
   
  }
}

export default LoanBadDebtPayOffForm; 
